// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: QKcL8BjU6-vp
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  generateStateValueProp,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicAddBankManuallyModal.module.css"; // plasmic-import: QKcL8BjU6-vp/css

createPlasmicElementProxy;

export const PlasmicAddBankManuallyModal__VariantProps = new Array();

export const PlasmicAddBankManuallyModal__ArgProps = new Array();

const $$ = {};

function PlasmicAddBankManuallyModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "accountNum.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ``
      },
      {
        path: "routingNum.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ``
      },
      {
        path: "address1.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "city.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "zip.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"vertStack"}
      data-plasmic-override={overrides.vertStack}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.vertStack
      )}
    >
      <div
        data-plasmic-name={"manualAdd"}
        data-plasmic-override={overrides.manualAdd}
        className={classNames(projectcss.all, sty.manualAdd)}
      >
        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames(projectcss.all, sty.freeBox)}
        >
          <div
            data-plasmic-name={"closeButton"}
            data-plasmic-override={overrides.closeButton}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.closeButton
            )}
          >
            {"X"}
          </div>
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__bwTNv
          )}
        >
          {"Account Number"}
        </div>
        <input
          data-plasmic-name={"accountNum"}
          data-plasmic-override={overrides.accountNum}
          className={classNames(
            projectcss.all,
            projectcss.input,
            sty.accountNum
          )}
          onChange={async (...eventArgs) => {
            (e => {
              generateStateOnChangeProp($state, ["accountNum", "value"])(
                e.target.value
              );
            }).apply(null, eventArgs);
          }}
          placeholder={``}
          ref={ref => {
            $refs["accountNum"] = ref;
          }}
          size={1}
          type={"text"}
          value={generateStateValueProp($state, ["accountNum", "value"]) ?? ""}
        />

        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__emKfh
          )}
        >
          {"Routing Number"}
        </div>
        <input
          data-plasmic-name={"routingNum"}
          data-plasmic-override={overrides.routingNum}
          className={classNames(
            projectcss.all,
            projectcss.input,
            sty.routingNum
          )}
          onChange={async (...eventArgs) => {
            (e => {
              generateStateOnChangeProp($state, ["routingNum", "value"])(
                e.target.value
              );
            }).apply(null, eventArgs);
          }}
          placeholder={``}
          ref={ref => {
            $refs["routingNum"] = ref;
          }}
          size={1}
          type={"text"}
          value={generateStateValueProp($state, ["routingNum", "value"]) ?? ""}
        />

        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__qoE9
          )}
        >
          {"Address"}
        </div>
        <input
          data-plasmic-name={"address1"}
          data-plasmic-override={overrides.address1}
          className={classNames(projectcss.all, projectcss.input, sty.address1)}
          onChange={async (...eventArgs) => {
            (e => {
              generateStateOnChangeProp($state, ["address1", "value"])(
                e.target.value
              );
            }).apply(null, eventArgs);
          }}
          placeholder={``}
          ref={ref => {
            $refs["address1"] = ref;
          }}
          size={1}
          type={"text"}
          value={generateStateValueProp($state, ["address1", "value"]) ?? ""}
        />

        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__zwjvk
          )}
        >
          {"City"}
        </div>
        <input
          data-plasmic-name={"city"}
          data-plasmic-override={overrides.city}
          className={classNames(projectcss.all, projectcss.input, sty.city)}
          onChange={async (...eventArgs) => {
            (e => {
              generateStateOnChangeProp($state, ["city", "value"])(
                e.target.value
              );
            }).apply(null, eventArgs);
          }}
          placeholder={``}
          ref={ref => {
            $refs["city"] = ref;
          }}
          size={1}
          type={"text"}
          value={generateStateValueProp($state, ["city", "value"]) ?? ""}
        />

        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__ip4Ro
          )}
        >
          {"State"}
        </div>
        <div
          data-plasmic-name={"selectState"}
          data-plasmic-override={overrides.selectState}
          className={classNames(projectcss.all, sty.selectState)}
        />

        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__nzFod
          )}
        >
          {"Zip Code"}
        </div>
        <input
          data-plasmic-name={"zip"}
          data-plasmic-override={overrides.zip}
          className={classNames(projectcss.all, projectcss.input, sty.zip)}
          onChange={async (...eventArgs) => {
            (e => {
              generateStateOnChangeProp($state, ["zip", "value"])(
                e.target.value
              );
            }).apply(null, eventArgs);
          }}
          placeholder={``}
          ref={ref => {
            $refs["zip"] = ref;
          }}
          size={1}
          type={"text"}
          value={generateStateValueProp($state, ["zip", "value"]) ?? ""}
        />

        <div
          data-plasmic-name={"submitButton"}
          data-plasmic-override={overrides.submitButton}
          className={classNames(projectcss.all, sty.submitButton)}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__dy0TR
            )}
          >
            {"Submit"}
          </div>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  vertStack: [
    "vertStack",
    "manualAdd",
    "freeBox",
    "closeButton",
    "accountNum",
    "routingNum",
    "address1",
    "city",
    "selectState",
    "zip",
    "submitButton"
  ],

  manualAdd: [
    "manualAdd",
    "freeBox",
    "closeButton",
    "accountNum",
    "routingNum",
    "address1",
    "city",
    "selectState",
    "zip",
    "submitButton"
  ],

  freeBox: ["freeBox", "closeButton"],
  closeButton: ["closeButton"],
  accountNum: ["accountNum"],
  routingNum: ["routingNum"],
  address1: ["address1"],
  city: ["city"],
  selectState: ["selectState"],
  zip: ["zip"],
  submitButton: ["submitButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAddBankManuallyModal__ArgProps,
          internalVariantPropNames: PlasmicAddBankManuallyModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAddBankManuallyModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "vertStack") {
    func.displayName = "PlasmicAddBankManuallyModal";
  } else {
    func.displayName = `PlasmicAddBankManuallyModal.${nodeName}`;
  }
  return func;
}

export const PlasmicAddBankManuallyModal = Object.assign(
  // Top-level PlasmicAddBankManuallyModal renders the root element
  makeNodeComponent("vertStack"),
  {
    // Helper components rendering sub-elements
    manualAdd: makeNodeComponent("manualAdd"),
    freeBox: makeNodeComponent("freeBox"),
    closeButton: makeNodeComponent("closeButton"),
    accountNum: makeNodeComponent("accountNum"),
    routingNum: makeNodeComponent("routingNum"),
    address1: makeNodeComponent("address1"),
    city: makeNodeComponent("city"),
    selectState: makeNodeComponent("selectState"),
    zip: makeNodeComponent("zip"),
    submitButton: makeNodeComponent("submitButton"),
    // Metadata about props expected for PlasmicAddBankManuallyModal
    internalVariantProps: PlasmicAddBankManuallyModal__VariantProps,
    internalArgProps: PlasmicAddBankManuallyModal__ArgProps
  }
);

export default PlasmicAddBankManuallyModal;
/* prettier-ignore-end */
